module.exports = __webpack_public_path__ + "static/media/qc-tasks.3fb63591.svg";